import { BrandJusIa, Drawer, IconButton, Menu, MenuIcon, MenuItem } from '@farol-ds/react'
import { Topbar } from '@jusbrasil/topbar'

import styles from './index.module.scss'

const IA_BASE_URL = 'https://ia.jusbrasil.com.br'

export const JusiaProductTopbar = () => {
  return (
    <div className={styles.topbar}>
      <div className={styles.leftArea}>
        <Drawer placement="left" size="sm">
          <Drawer.Trigger>
            <IconButton icon={<MenuIcon />} label="Menu" className={styles.mobileMenuTrigger} />
          </Drawer.Trigger>
          <Drawer.Content>
            <Drawer.IconClose />
            <Drawer.Header>
              <Drawer.HeaderTitle>Jus IA</Drawer.HeaderTitle>
            </Drawer.Header>
            <Drawer.Body>
              <Menu>
                <MenuItem asChild>
                  <a href={IA_BASE_URL}>
                    <MenuItem.Content>Home</MenuItem.Content>
                  </a>
                </MenuItem>
                <MenuItem asChild>
                  <a href={`${IA_BASE_URL}/sobre`}>
                    <MenuItem.Content>Sobre</MenuItem.Content>
                  </a>
                </MenuItem>
                <MenuItem asChild>
                  <a href={`${IA_BASE_URL}/planos`}>
                    <MenuItem.Content>Planos e preços</MenuItem.Content>
                  </a>
                </MenuItem>
                <MenuItem asChild>
                  <a href={`${IA_BASE_URL}/estudo`}>
                    <MenuItem.Content>Estudo Jusbrasil</MenuItem.Content>
                  </a>
                </MenuItem>
              </Menu>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer>
        <BrandJusIa width={79} height={22} />
        <Menu orientation="horizontal" className={styles.globalMenu}>
          <MenuItem asChild>
            <a href={IA_BASE_URL}>
              <MenuItem.Content>Home</MenuItem.Content>
            </a>
          </MenuItem>
          <MenuItem asChild>
            <a href={`${IA_BASE_URL}/sobre`}>
              <MenuItem.Content>Sobre</MenuItem.Content>
            </a>
          </MenuItem>
          <MenuItem asChild>
            <a href={`${IA_BASE_URL}/planos`}>
              <MenuItem.Content>Planos e preços</MenuItem.Content>
            </a>
          </MenuItem>
          <MenuItem asChild>
            <a href={`${IA_BASE_URL}/estudo`}>
              <MenuItem.Content>Estudo Jusbrasil</MenuItem.Content>
            </a>
          </MenuItem>
        </Menu>
      </div>
      <div className={styles.rightArea}>
        <Topbar className={styles.topbarContainer}>
          <Topbar.UserMenu />
        </Topbar>
      </div>
    </div>
  )
}
